'use client';
import { toast } from "sonner";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import ApiServices from '../services/apiservices';
import { errorMessage } from './errormessage';
import config from "../config/config";

const env = process.env.NODE_ENV;

const server = config[env];
const clientUrl = server?.clientUri;

const SignInForm = () => {
  const initialValues = {
    email: '',
    password: '',
  };

  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string()
    // .min(6, 'Minimum 6 characters')
  .required('Required'),
  });

  const handleSubmit = async (values, actions) => {
    try {
      const { success, message, userInfo,accessToken,authenticated} = await ApiServices.postRequestNoAuth(
        "/user/login.php",values 
      );
     
      
      if (success) {
        toast.success(message);        
        ApiServices.setLocalStorage("access-token", accessToken);
        ApiServices.setLocalStorage("user", userInfo);
        ApiServices.setLocalStorage("authenticated", authenticated);
        window.location.replace(`${clientUrl}/admin`);
      } else {        
        actions.resetForm(); 
        toast.error(message);
      }
    } catch (error) {
      toast.error(errorMessage(error));
    } finally {
      actions.setSubmitting(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="bg-[#161b22] p-8 rounded-lg w-full max-w-md shadow-xl">
        <div className="flex justify-center mb-6">
          <div className="text-green-500 text-4xl font-bold bg-white">
            <a href="/"><img src='/images/BEDCLogo.png' alt="BEDCLogo.png"/></a>  
            </div>
        </div>
        {/* <h2 className="text-white text-center text-xl font-semibold mb-6">
          Login
        </h2> */}

        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form className="space-y-6">
              <div>
                <label className="text-white block mb-1">Email address</label>
                <Field
                  name="email"
                  type="email"
                  className="w-full px-4 py-2 rounded bg-[#0d1117] border border-green-600 text-white focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                <ErrorMessage name="email" component="div" className="text-red-500 text-sm mt-1" />
              </div>

              <div>
                <label className="text-white block mb-1">Password</label>
                <div className="flex justify-between">
                  <a href="/forgot-password" className="text-green-500 text-sm ml-auto mb-1 hover:underline">
                    Forgot password?
                  </a>
                </div>
                <Field
                  name="password"
                  type="password"
                  className="w-full px-4 py-2 rounded bg-[#0d1117] border border-[#2d333b] text-white focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                <ErrorMessage name="password" component="div" className="text-red-500 text-sm mt-1" />
              </div>

              <div className="flex items-center">
                <Field type="checkbox" name="remember" className="mr-2" />
                <label className="text-white text-sm">Remember me</label>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-green-600 text-white py-2 rounded w-full hover:bg-green-700 transition"
              >
                Sign in
              </button>
            </Form>
          )}
        </Formik>

        <p className="mt-6 text-center text-green-500 hover:underline text-sm">
          {/* <a href="#">Create your account</a> */}
        </p>
      </div>
    </div>
  );
};

export default SignInForm;
